module.exports = __webpack_public_path__ + "static/img/wx2.875a0c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wx2.jpg
// module id = wTpr
// module chunks = 5